import { Injectable } from '@angular/core';
import { EnumMeasureTypes } from '@library/store/measures/measures.interface';
import { ConsumptionGroup } from '../control-page-footer-consumption.component';
import { ConsumptionUnit, ControlPageStore } from '@pages/control-page/control-page-store.service';
import { BehaviorSubject, map } from 'rxjs';

@Injectable()
export class ControlPageFooterAppliancesService {

  selectedGroup = new BehaviorSubject<ConsumptionGroup>(null);
  selectedGroup$ = this.selectedGroup.asObservable();

  measureType$ = this.controlPageStore.homeConsumptionUnit$.pipe(
    map(unit => {
      return unit === ConsumptionUnit.CONSUMPTION
        ? EnumMeasureTypes.SUM_ENERGY_BUY_FROM_GRID_BASE
        : EnumMeasureTypes.SUM_ENERGY_BUY_FROM_GRID_PRICE_BASE;
    }),
  );

  constructor(
    private controlPageStore: ControlPageStore,
  ) {}
}
